import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold gradient-text mb-6">
        Welcome to Meradio
      </h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="card">
          <h2 className="text-xl font-semibold text-meradio-dark mb-2">
            🎵 Music Discovery
          </h2>
          <p className="text-meradio-dark-light">
            Discover new electronic music from your favorite YouTube channels with AI-powered audio analysis.
          </p>
        </div>
        
        <div className="card">
          <h2 className="text-xl font-semibold text-meradio-dark mb-2">
            🎧 DJ Tools
          </h2>
          <p className="text-meradio-dark-light">
            Professional mixing tools with BPM detection, key analysis, and Camelot wheel compatibility.
          </p>
        </div>
        
        <div className="card">
          <h2 className="text-xl font-semibold text-meradio-dark mb-2">
            🎛️ Real-time Streaming
          </h2>
          <p className="text-meradio-dark-light">
            Join streaming rooms, take DJ control, and experience synchronized music with others.
          </p>
        </div>
      </div>
      
      <div className="mt-8 card">
        <h2 className="text-2xl font-bold text-meradio-dark mb-4">
          Getting Started
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-lg font-semibold text-meradio-secondary mb-2">
              1. Follow Channels
            </h3>
            <p className="text-meradio-dark-light mb-4">
              Search and follow your favorite YouTube music channels to automatically import their latest videos.
            </p>
            <Button variant="primary" onClick={() => navigate('/channels?tab=search')}>
              Browse Channels
            </Button>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-meradio-secondary mb-2">
              2. Explore Videos
            </h3>
            <p className="text-meradio-dark-light mb-4">
              View your music feed with advanced audio features, BPM, key detection, and mood analysis.
            </p>
            <Button variant="secondary" onClick={() => navigate('/videos')}>
              View Videos
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
